import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputSwitch } from 'primereact/inputswitch';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { handleGetRequest } from '../../service/GetTemplate';
import { handlePutRequest } from '../../service/PutTemplate';
import { endPoints } from '../../Config';
import { useDispatch } from 'react-redux';
import ActiveInactiveDialog from '../../components/ActiveInactiveDialog';
import EditViewTeam from './EditViewTeam';
import usePreferredLanguage from '../../utilities/usePreferredLanguage';
import { translateUiText } from '../../utilities/siteTranslations';

const Teams = () => {
    const preferredLanguage = usePreferredLanguage();
    const t = (value) => translateUiText(value, preferredLanguage);
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [rowRecord, setRowRecord] = useState(null);
    const [allTeams, setAllTeams] = useState([]);
    const [editable, setEditable] = useState(false);
    const [viewable, setViewable] = useState(false);
    const [switchData, setSwitchData] = useState(null);
    const [switchModal, setSwitchModal] = useState(false);
    // const [loadingBtn, setLoadingBtn] = useState(false);

    // const permissionsList = useSelector((state) => state?.pagePermissions?.permissions || []);

    // const dt = React.useRef(null);
    const dispatch = useDispatch();

    const handleAdd = () => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(false);
    };

    const handleEdit = (rowData) => {
        setShowAddDialog(true);
        setEditable(true);
        setViewable(false);
        setRowRecord(rowData);
    };

    const handleView = (rowData) => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(true);
        setRowRecord(rowData);
    };

    const onHide = () => {
        setShowAddDialog(false);
        getTeamList();
    };
    const onClose = () => {
        setShowAddDialog(false);
    };

    const handleInputSwitch = async () => {
        // setLoadingBtn(true);

        let data = {
            isActive: switchData?.isActive ? false : true,
            RoleName: switchData?.roleName
        };

        const response = await dispatch(handlePutRequest(data, endPoints?.updateRole, false, true));

        if (response?.status === 200) {
            getTeamList();
        }

        // setLoadingBtn(false);
        handleSwitchModalClose();
    };

    const handleSwitchModalOpen = () => {
        setSwitchModal(true);
    };

    const handleSwitchModalClose = () => {
        setSwitchModal(false);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    {/* {' '}
                    <InputSwitch
                        tooltip="Status"
                        tooltipOptions={{ position: 'top' }}
                        checked={rowData.isActive}
                        onChange={() => {
                            handleSwitchModalOpen();
                            setSwitchData(rowData);
                        }}
                    /> */}
                    {/* {permissionsList?.updateAllowed === 'Y' && ( */}
                    <Button
                        tooltip={t('Edit')}
                        icon="pi pi-pencil"
                        tooltipOptions={{ position: 'top' }}
                        disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.status === 'N') ? true : false}
                        onClick={() => {
                            handleEdit(rowData);
                        }}
                        className="p-button-rounded p-button-primary mr-2 ml-2"
                    />
                    {/* )} */}
                    {/* {permissionsList?.viewAllowed === 'Y' && ( */}
                    <Button
                        tooltip={t('View')}
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-eye"
                        onClick={() => {
                            handleView(rowData);
                        }}
                        className="p-button-rounded"
                        style={{ backgroundColor: '#F2AC57', border: 'none' }}
                    />
                    {/* )} */}
                </div>
            </>
        );
    };

    const getTeamList = async () => {
        const response = await handleGetRequest(endPoints.getallteams, true, false, dispatch);
        if (response) {
            setAllTeams(response?.data);
        }
    };

    useEffect(() => {
        getTeamList();
    }, []);

    return (
        <div className="p-4">
            <Dialog header={<div>{editable ? t('Edit Team') : viewable ? t('View Team') : t('Add Team')}</div>} visible={showAddDialog} onHide={onClose} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }} draggable={false}>
                <EditViewTeam rowRecord={rowRecord} editable={editable} viewable={viewable} onHide={onHide} onClose={onClose} />
            </Dialog>

            <ActiveInactiveDialog visible={switchModal} onHide={handleSwitchModalClose} onConfirm={handleInputSwitch} onCancel={handleSwitchModalClose} status={switchData?.isActive} />

            <div className="flex justify-content-between align-items-center mb-3">
                <h3>{t('Teams')}</h3>

                {/* <div className="flex gap-2">{permissionsList?.insertAllowed === 'Y' && <Button label="Add New" icon="pi pi-plus" className="p-button-success p-button-sm" onClick={() => handleAdd()} />}</div> */}
                <div className="flex gap-2">{/* <Button label="Add New" icon="pi pi-plus" className="p-button-success p-button-sm" onClick={() => handleAdd()} /> */}</div>
            </div>

            <DataTable
                paginator
                rows={15}
                rowsPerPageOptions={[5, 10, 20]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate={t('Showing {first} to {last} of {totalRecords} Records')}
                emptyMessage={t('No List found.')}
                responsiveLayout="scroll"
                value={allTeams}
                className="p-datatable-sm datatable-responsive"
            >
                {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column> */}
                {/* <Column field="id" header="SL" body={(rowData, options) => options.rowIndex + 1} style={{ width: '60px' }} /> */}
                <Column field="name" header={t('Team Name')} />
                <Column
                    field="head"
                    header={t('Team Lead')}
                    body={(rowData) => {
                        const head = rowData?.head;
                        if (!head) return '';
                        if (typeof head === 'string') return head;
                        return head.firstName + ' ' + head.lastName;
                    }}
                />
                <Column header={t('Actions')} body={actionBodyTemplate} className="Table__ActionHeading__CentredAlign" />
            </DataTable>
        </div>
    );
};

export default Teams;
